import { useInfiniteQuery } from "@tanstack/react-query";
import { Buton, Iskelet, Kart } from "@koclukpanel/ui";
import { kocDavetleri, kocSiparisleri } from "./api-magaza";
import { SIPARIS_DURUMU_ETIKETI } from "./magaza-tipleri";

/**
 * KOÇ ÖDÜL MERKEZİ — YALNIZ GÖRÜR (sürüm 9a, Emre kararı 07.10.2026).
 *
 * Koç kendi öğrencilerinin siparişlerini ve davetlerini okur; ürün, çark, sipariş işleme (kargo, iptal) ve kural
 * düğmeleri bu dosyada YOK ve çizilmiyor — onlar `oyun.*.yonet` izinli rollerin ekranında (OyunYonetimi). Kapsam
 * (yalnız atanmış öğrenciler) SUNUCUDA süzülüyor; bu ekran sunucunun cevabını gösterir. Adres ve aday adı/telefonu
 * hiçbir uçtan dönmez.
 */

const DAVET_DURUMU_ETIKETI: Record<string, string> = {
  KOD_GIRILDI: "Kod girildi",
  BEKLEMEDE: "Ödeme bekleniyor",
  PUAN_YAZILDI: "Puan yazıldı",
};

export function KocSiparisGecmisi() {
  const q = useInfiniteQuery({
    queryKey: ["koc-siparisleri"],
    queryFn: ({ pageParam }) => kocSiparisleri(pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (son) => son.sonraki ?? undefined,
    retry: false,
  });
  const satirlar = q.data?.pages.flatMap((p) => p.satirlar) ?? [];
  return (
    <Kart
      baslik="Sipariş geçmişi"
      aciklama="Öğrencilerinizin mağaza siparişleri. Yalnız görüntülenir; teslim adresi gösterilmez."
    >
      {q.isPending ? (
        <Iskelet satir={4} />
      ) : q.isError ? (
        <p role="alert" className="text-hata-700 text-sm">
          Siparişler alınamadı.
        </p>
      ) : satirlar.length === 0 ? (
        <p className="text-notr-600 text-sm">Öğrencilerinizin henüz siparişi yok.</p>
      ) : (
        <>
          <ul className="divide-notr-100 divide-y text-sm">
            {satirlar.map((s) => (
              <li key={s.id} className="flex flex-wrap items-center justify-between gap-2 py-2">
                <div>
                  <p className="text-notr-900">
                    {s.ogrenciAdi} · {s.urunAdi}
                  </p>
                  <p className="text-notr-600 text-xs">{s.tarih.slice(0, 10)}</p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-notr-700">
                    {SIPARIS_DURUMU_ETIKETI[s.durum] ?? s.durum}
                  </span>
                  <span className="font-semibold tabular-nums">{s.puan} puan</span>
                </div>
              </li>
            ))}
          </ul>
          {q.hasNextPage && (
            <div className="mt-2">
              <Buton
                gorunum="ikincil"
                disabled={q.isFetchingNextPage}
                onClick={() => void q.fetchNextPage()}
              >
                Daha fazla yükle
              </Buton>
            </div>
          )}
        </>
      )}
    </Kart>
  );
}

export function KocDavetleri() {
  const q = useInfiniteQuery({
    queryKey: ["koc-davetleri"],
    queryFn: ({ pageParam }) => kocDavetleri(pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (son) => son.sonraki ?? undefined,
    retry: false,
  });
  const satirlar = q.data?.pages.flatMap((p) => p.satirlar) ?? [];
  return (
    <Kart
      baslik="Davet ettikleri"
      aciklama="Öğrencilerinizin davet kodları ve davet edilenlerin durumu. Davet edilenin adı ve iletişim bilgisi gösterilmez."
    >
      {q.isPending ? (
        <Iskelet satir={3} />
      ) : q.isError ? (
        <p role="alert" className="text-hata-700 text-sm">
          Davetler alınamadı.
        </p>
      ) : satirlar.length === 0 ? (
        <p className="text-notr-600 text-sm">Öğrencilerinizin henüz daveti yok.</p>
      ) : (
        <>
          <ul className="divide-notr-100 divide-y text-sm">
            {satirlar.map((d) => (
              <li key={d.davetId} className="py-2">
                <p className="text-notr-900">
                  {d.ogrenciAdi} · <span className="font-mono">{d.kod}</span>
                </p>
                <p className="text-notr-600 text-xs">
                  {d.adaylar.length === 0
                    ? "Henüz davet edilen yok"
                    : d.adaylar.map((a) => DAVET_DURUMU_ETIKETI[a.durum] ?? a.durum).join(" · ")}
                </p>
              </li>
            ))}
          </ul>
          {q.hasNextPage && (
            <div className="mt-2">
              <Buton
                gorunum="ikincil"
                disabled={q.isFetchingNextPage}
                onClick={() => void q.fetchNextPage()}
              >
                Daha fazla yükle
              </Buton>
            </div>
          )}
        </>
      )}
    </Kart>
  );
}
